/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: p8FkKgCnyuat1kHSEYAKfW

import { createUseGlobalVariants } from "@plasmicapp/react-web";

import { useScreenVariants as useScreenVariants_33Bo6T6AaBqtV } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: 33bo6t6aaBqtV/globalVariant

export const _useGlobalVariants = createUseGlobalVariants({
  screen: useScreenVariants_33Bo6T6AaBqtV
});
